module.exports = __webpack_public_path__ + "img/manage-default.9d3265af.svg";